import { isNull } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useAntMedia } from 'providers/AntMediaProvider'
import { useEffect, useRef, useState } from 'react'
import { useStore } from '../../stores'
import { Video } from '../index'
import { VideoContainer } from './styles'

export type LocationVideoType = 'top' | 'bottom'

const WebrtcStream = observer(() => {
  const { rouletteStore } = useStore()
  const { streamDataStore } = rouletteStore
  const containerMainRef = useRef<HTMLDivElement>(null)
  const [locationVideo, setLocationVideo] = useState<LocationVideoType>('top')
  const { cleanupStream } = useAntMedia()

  useEffect(() => {
    return () => {
      cleanupStream()
    }
  }, [])

  return (
    <VideoContainer ref={containerMainRef} locationVideo={locationVideo}>
      {!isNull(streamDataStore.streamData) && (
        <Video
          data={streamDataStore.streamData}
          offsetHeight={(videoHeight) => {
            if (!containerMainRef.current) return

            const containerHeight = containerMainRef.current.offsetHeight

            setLocationVideo(videoHeight > containerHeight ? 'bottom' : 'top')
          }}
        />
      )}
    </VideoContainer>
  )
})

export default WebrtcStream
